export const ACCOUNTING_PROCESS_STEPS = {
  PENDIENTE: 0,
  DOCUMENTOS_SOLICITADOS: 1,
  DOCUMENTOS_EN_REVISION: 2,
  SERVICIO_EN_PROCESO: 3,
  REVISION_DEL_CLIENTE: 4,
  SUBIDA_DOCUMENTOS_MULTIPLES: 5,
  IMPUESTOS_PAGADOS: 6,
} as const

export const ACCOUNTING_STATUS_CATALOGUE = {
  PENDIENTE: 1,
  DOCUMENTOS_SOLICITADOS: 2,
  SOLICITUD_DE_DOCUMENTOS: 3,
  DOCUMENTOS_EN_REVISION: 4,
  SERVICIO_EN_PROCESO: 8,
  REVISION_DEL_CLIENTE: 7,
  SUBIDA_DOCUMENTOS_MULTIPLES: 5,
  IMPUESTOS_PAGADOS: 6,
} as const

export const ACCOUNTING_STEP_FOUR_VALIDATION_STEPS = {
  FILES_UPLOADED: 'FILES_UPLOADED',
  FILES_VALIDATION: 'FILES_VALIDATION',
} as const

export const ACCOUNTING_STEP_FIVE_VALIDATION_STEPS = {
  FIRST_CATEGORY_FILES_UPLOADED: 'FIRST_CATEGORY_FILES_UPLOADED',
  FIRST_CATEGORY_FILES_VALIDATION: 'FIRST_CATEGORY_FILES_VALIDATION',
  THIRD_CATEGORY_FILES_UPLOADED: 'THIRD_CATEGORY_FILES_UPLOADED',
  THIRD_CATEGORY_FILES_VALIDATION: 'THIRD_CATEGORY_FILES_VALIDATION',
  DEFAULT: 'DEFAULT',
} as const
